import { TariffCategory } from '../../shared/models/types'
import { TariffResponseDto } from '../../tariffs/api/dto/tariffs.dto'
import { MOCK_TARIFF_ID, MOCK_CURRENCY, MOCK_ENERGY_TYPE, MOCK_WALLBOX_ID } from './mock-properties'

export const MOCK_TARIFFS: TariffResponseDto = {
  dynamicTariffActivated: true,
  tariffs: [
    {
      tariffId: MOCK_TARIFF_ID,
      tariffCategory: TariffCategory.dynamicTariff,
      installationId: 9372,
      wallboxConnector: {
        '00141648D96AA301': '1',
        '00141648D96C1A01': '1',
        '00141648D96C2701': '1',
        '00141648D96DEF01': '1',
        '00141648D96E6501': '1',
        '00141648D974EB01': '1',
        '00141648D9795C01': '1',
        '00141648D979B301': '1',
      },
      connectorId: '1',
      coreTariffDto: {
        id: MOCK_TARIFF_ID,
        currency: MOCK_CURRENCY,
        type: null,
        elements: [
          {
            restrictions: {
              reservation: null,
              start_date_time: '2025-06-22T07:00',
              end_date_time: '2025-06-22T07:59',
              min_kwh: null,
              max_kwh: null,
              min_current: null,
              max_current: null,
              min_power: null,
              max_power: null,
              min_duration: null,
              max_duration: null,
              day_of_week: null,
            },
            price_components: [
              {
                type: MOCK_ENERGY_TYPE,
                price: 0.0649,
                vat: 19,
                step_size: 1,
              },
            ],
          },
          {
            restrictions: {
              reservation: null,
              start_date_time: '2025-06-22T08:00',
              end_date_time: '2025-06-22T08:59',
              min_kwh: null,
              max_kwh: null,
              min_current: null,
              max_current: null,
              min_power: null,
              max_power: null,
              min_duration: null,
              max_duration: null,
              day_of_week: null,
            },
            price_components: [
              {
                type: MOCK_ENERGY_TYPE,
                price: 0.002,
                vat: 19,
                step_size: 1,
              },
            ],
          },
          {
            restrictions: {
              reservation: null,
              start_date_time: '2025-06-22T09:00',
              end_date_time: '2025-06-22T09:59',
              min_kwh: null,
              max_kwh: null,
              min_current: null,
              max_current: null,
              min_power: null,
              max_power: null,
              min_duration: null,
              max_duration: null,
              day_of_week: null,
            },
            price_components: [
              {
                type: MOCK_ENERGY_TYPE,
                price: 0,
                vat: 19,
                step_size: 1,
              },
            ],
          },
          {
            restrictions: {
              reservation: null,
              start_date_time: '2025-06-22T10:00',
              end_date_time: '2025-06-22T10:59',
              min_kwh: null,
              max_kwh: null,
              min_current: null,
              max_current: null,
              min_power: null,
              max_power: null,
              min_duration: null,
              max_duration: null,
              day_of_week: null,
            },
            price_components: [
              {
                type: MOCK_ENERGY_TYPE,
                price: -0.0023,
                vat: 19,
                step_size: 1,
              },
            ],
          },
          {
            restrictions: {
              reservation: null,
              start_date_time: '2025-06-22T11:00',
              end_date_time: '2025-06-22T11:59',
              min_kwh: null,
              max_kwh: null,
              min_current: null,
              max_current: null,
              min_power: null,
              max_power: null,
              min_duration: null,
              max_duration: null,
              day_of_week: null,
            },
            price_components: [
              {
                type: MOCK_ENERGY_TYPE,
                price: -0.0152,
                vat: 19,
                step_size: 1,
              },
            ],
          },
          {
            restrictions: {
              reservation: null,
              start_date_time: '2025-06-22T12:00',
              end_date_time: '2025-06-22T12:59',
              min_kwh: null,
              max_kwh: null,
              min_current: null,
              max_current: null,
              min_power: null,
              max_power: null,
              min_duration: null,
              max_duration: null,
              day_of_week: null,
            },
            price_components: [
              {
                type: MOCK_ENERGY_TYPE,
                price: -0.0183,
                vat: 19,
                step_size: 1,
              },
            ],
          },
          {
            restrictions: {
              reservation: null,
              start_date_time: '2025-06-22T13:00',
              end_date_time: '2025-06-22T13:59',
              min_kwh: null,
              max_kwh: null,
              min_current: null,
              max_current: null,
              min_power: null,
              max_power: null,
              min_duration: null,
              max_duration: null,
              day_of_week: null,
            },
            price_components: [
              {
                type: MOCK_ENERGY_TYPE,
                price: -0.013,
                vat: 19,
                step_size: 1,
              },
            ],
          },
          {
            restrictions: {
              reservation: null,
              start_date_time: '2025-06-22T14:00',
              end_date_time: '2025-06-22T14:59',
              min_kwh: null,
              max_kwh: null,
              min_current: null,
              max_current: null,
              min_power: null,
              max_power: null,
              min_duration: null,
              max_duration: null,
              day_of_week: null,
            },
            price_components: [
              {
                type: MOCK_ENERGY_TYPE,
                price: 0.36,
                vat: 19,
                step_size: 1,
              },
            ],
          },
          {
            restrictions: {
              reservation: null,
              start_date_time: '2025-06-22T15:00',
              end_date_time: '2025-06-22T15:59',
              min_kwh: null,
              max_kwh: null,
              min_current: null,
              max_current: null,
              min_power: null,
              max_power: null,
              min_duration: null,
              max_duration: null,
              day_of_week: null,
            },
            price_components: [
              {
                type: MOCK_ENERGY_TYPE,
                price: 0,
                vat: 19,
                step_size: 1,
              },
            ],
          },
          {
            restrictions: {
              reservation: null,
              start_date_time: '2025-06-22T16:00',
              end_date_time: '2025-06-22T16:59',
              min_kwh: null,
              max_kwh: null,
              min_current: null,
              max_current: null,
              min_power: null,
              max_power: null,
              min_duration: null,
              max_duration: null,
              day_of_week: null,
            },
            price_components: [
              {
                type: MOCK_ENERGY_TYPE,
                price: 0.0595,
                vat: 19,
                step_size: 1,
              },
            ],
          },
          {
            restrictions: {
              reservation: null,
              start_date_time: '2025-06-22T17:00',
              end_date_time: '2025-06-22T17:59',
              min_kwh: null,
              max_kwh: null,
              min_current: null,
              max_current: null,
              min_power: null,
              max_power: null,
              min_duration: null,
              max_duration: null,
              day_of_week: null,
            },
            price_components: [
              {
                type: MOCK_ENERGY_TYPE,
                price: 0.1271,
                vat: 19,
                step_size: 1,
              },
            ],
          },
          {
            restrictions: {
              reservation: null,
              start_date_time: '2025-06-22T18:00',
              end_date_time: '2025-06-22T18:59',
              min_kwh: null,
              max_kwh: null,
              min_current: null,
              max_current: null,
              min_power: null,
              max_power: null,
              min_duration: null,
              max_duration: null,
              day_of_week: null,
            },
            price_components: [
              {
                type: MOCK_ENERGY_TYPE,
                price: 0.1369,
                vat: 19,
                step_size: 1,
              },
            ],
          },
          {
            restrictions: {
              reservation: null,
              start_date_time: '2025-06-22T19:00',
              end_date_time: '2025-06-22T19:59',
              min_kwh: null,
              max_kwh: null,
              min_current: null,
              max_current: null,
              min_power: null,
              max_power: null,
              min_duration: null,
              max_duration: null,
              day_of_week: null,
            },
            price_components: [
              {
                type: MOCK_ENERGY_TYPE,
                price: 0.1515,
                vat: 19,
                step_size: 1,
              },
            ],
          },
          {
            restrictions: {
              reservation: null,
              start_date_time: '2025-06-22T20:00',
              end_date_time: '2025-06-22T20:59',
              min_kwh: null,
              max_kwh: null,
              min_current: null,
              max_current: null,
              min_power: null,
              max_power: null,
              min_duration: null,
              max_duration: null,
              day_of_week: null,
            },
            price_components: [
              {
                type: MOCK_ENERGY_TYPE,
                price: 0.1398,
                vat: 19,
                step_size: 1,
              },
            ],
          },
          {
            restrictions: {
              reservation: null,
              start_date_time: '2025-06-22T21:00',
              end_date_time: '2025-06-22T21:59',
              min_kwh: null,
              max_kwh: null,
              min_current: null,
              max_current: null,
              min_power: null,
              max_power: null,
              min_duration: null,
              max_duration: null,
              day_of_week: null,
            },
            price_components: [
              {
                type: MOCK_ENERGY_TYPE,
                price: 0.1228,
                vat: 19,
                step_size: 1,
              },
            ],
          },
        ],
        country_code: 'DE',
        party_id: 'HGE',
        tariff_alt_text: null,
        tariff_alt_url: null,
        min_price: null,
        max_price: null,
        start_date_time: '2025-06-22T07:06:01',
        end_date_time: '2025-06-22T07:06:01',
        energy_mix: null,
        last_updated: '2025-06-22T07:06:01',
      },
      createdBy: null,
      lastUpdated: '2025-03-26T13:53:01Z',
      dischargePrice: 2,
      tariffName: 'Dynamic tariff',
    },
    {
      tariffId: MOCK_WALLBOX_ID,
      tariffCategory: TariffCategory.staticTariff,
      installationId: 9372,
      wallboxConnector: {},
      connectorId: '',
      coreTariffDto: {
        id: MOCK_WALLBOX_ID,
        currency: MOCK_CURRENCY,
        type: 'REGULAR',
        elements: [
          {
            restrictions: null,
            price_components: [
              {
                type: MOCK_ENERGY_TYPE,
                price: 0.22,
                vat: 19,
                step_size: 1,
              },
              {
                type: 'FLAT',
                price: 0.1,
                vat: 19,
                step_size: 1,
              },
            ],
          },
        ],
        country_code: 'DE',
        party_id: 'HGE',
        tariff_alt_text: null,
        tariff_alt_url: null,
        min_price: null,
        max_price: null,
        start_date_time: '2025-06-23T07:06:01',
        end_date_time: '2028-06-23T07:06:01',
        energy_mix: null,
        last_updated: '2025-06-12T21:05:23',
      },
      createdBy: null,
      lastUpdated: '2025-06-12T21:05:23Z',
      dischargePrice: null,
      tariffName: 'Tariff 6',
    },
  ],
} as const
